<ng-container *ngIf="data.success; else noData">
	<dl-section-header [subTitle]="subTitle" [title]="title" [showSectionSeparator]="false" [asOfDate]="asOfDate"></dl-section-header>
	<bfa-accordion>
		<ng-container *ngFor="let tab of totalRiskDecompositionTabs; index as idx">
			<accordion-panel
				[isCollapsed]="!tab?.portfolio?.displayConfig?.active"
				(onToggleChange)="parentCollapsed[idx] = !parentCollapsed[idx]"
				*ngIf="tab?.portfolio?.displayConfig?.visible"
			>
				<header><dl-tooltip-section-header [tab]="tab?.portfolio"></dl-tooltip-section-header></header>
				<content>
					<bfa-tabs type="underline" [hideTabBarIfOneTab]="true" custom-classes="toggle-buttons">
						<ng-container *ngFor="let tabCategory of tab | keyvalue : tabNameComparator">
							<tab-panel
								[tab-title]="tabViewCategory[(tabCategory?.key | uppercase) + '_TAB'] | dcr : (tabCategory?.key | uppercase) + '_TAB'"
								[templateRef]="tabContent"
							></tab-panel>
							<ng-template #tabContent>
								<ng-container *ngIf="!tabCategory?.value?.error; else tabError">
									<content *ngIf="tabCategory?.value?.config.id === 'total.risk.characteristics'">
										<risk-characteristics-table [tab]="tabCategory?.value" [asOfDateSNP]="asOfDateSNP" tabId="total.risk.characteristics">
										</risk-characteristics-table>
									</content>
									<content *ngIf="tabCategory?.value?.config.id.includes('risk.decomposition')">
										<ng-container *ngIf="tabCategory?.key === 'portfolio'">
											<risk-characteristic-insights *componentId="'total.risk.decomposition.insights'; let res" [data]="res"></risk-characteristic-insights>
										</ng-container>
										<ng-container *ngIf="tabCategory?.key === 'benchmark'">
											<risk-characteristic-insights *componentId="'active.risk.decomposition.insights'; let res" [data]="res"></risk-characteristic-insights>
										</ng-container>
										<bfa-tabs [activate-on-mobile]="true">
											<tab-panel tab-title="Table" [templateRef]="table"></tab-panel>
											<tab-panel tab-title="Graph" [templateRef]="graph"></tab-panel>
										</bfa-tabs>
										<ac-disclosure>
											<ac-tpm-disclosure></ac-tpm-disclosure>
											<span dcrHTMLKey="TOTAL_RISK_DECOMPOSITION_DISCLAIMER">TOTAL_RISK_DECOMPOSITION_DISCLAIMER</span>
										</ac-disclosure>
									</content>
									<ng-template #table>
										<dl-display-table
											[attr.data-cy]="tabCategory?.value?.config?.id + '-table'"
											class="col-12 col-sm-24"
											[data]="tabCategory?.value"
											[total]="tabCategory?.key === 'benchmark' ? activeTotalTab : totalTab"
											[parentCollapsed]="parentCollapsed[idx]"
											[striped]="true"
										></dl-display-table>
									</ng-template>
									<ng-template #graph>
										<bfa-chart
											type="column"
											name="risk"
											[data]="tabCategory?.value"
											[hasFullHeight]="true"
											class="col-12 col-sm-24"
											[customAttributes]="{
												contributionTooltipTabData: tabCategory?.value?.config?.id?.includes('active')
													? {}
													: data.tab['total.risk.risk.decomposition.contributions']
											}"
										></bfa-chart>
									</ng-template>
								</ng-container>
							</ng-template>
						</ng-container>
					</bfa-tabs>
				</content>
			</accordion-panel>
		</ng-container>
	</bfa-accordion>
</ng-container>
<ng-template #noData>
	<dl-no-data [data]="data"></dl-no-data>
</ng-template>
